import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { BrandFormModel } from "@tCooneyBrothers/ApiModels";
import { addBrandFormFields } from "@tCooneyBrothers/Services/CustomBrandServiceForm";
import { CustomApiHandler } from "@tCooneyBrothers/Store/CustomHandlerCreator";

type HandlerType = {
    onSuccess?: () => void;
    onError?: () => void;
} & CustomApiHandler<BrandFormModel, BrandFormModel>;

export const DispatchBeginCustomBrandFormFields: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomBrandFormFields/BeginCustomBrandFormFields"
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await addBrandFormFields(props.parameter);
};

export const DispatchCompletedCustomBrandFormFields: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomBrandFormFields/CompletedCustomBrandFormFields",
    });
};
export const ExecuteOnErrorCallback: HandlerType = props => {
        props.parameter.onError?.();
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
        props.parameter.onSuccess?.();
};

export const chain = [DispatchBeginCustomBrandFormFields, PopulateApiParameter, RequestDataFromApi, DispatchCompletedCustomBrandFormFields, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const addCustomBrandFormFormFields = createHandlerChainRunner(chain, "AddCustomBrandFormFields");
export default addCustomBrandFormFormFields;
